// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__29dSo","modalFooterButton":"ModalNotes_modalFooterButton__2LDL4"};